import { render } from "./BaseTextInput.vue?vue&type=template&id=524273d2&scoped=true"
import script from "./BaseTextInput.vue?vue&type=script&lang=js"
export * from "./BaseTextInput.vue?vue&type=script&lang=js"

import "./BaseTextInput.vue?vue&type=style&index=0&id=524273d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524273d2"]])

export default __exports__